// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XoSp","title":"Header_title__RwNlQ","side":"Header_side__1G2ZR"};